import React from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

import bgHero from "../images/bg-hero.png";
import svgArrowBtn from "../images/arrow-btn.svg";

// ====== IMPORTS EXISTANTS UNIQUEMENT ======
// Si un fichier n'existe pas encore, ne l'importe pas.
// Mets simplement sa valeur à null dans l'objet project plus bas.




import test from "../images/projects/teste.png";

// Exemple vidéo si tu en as une plus tard
// import pacteVideo from "../videos/projects/pacte/pacte-showcase.mp4";

export default function ProjectDetailPage() {
  const { slug } = useParams();

  const projects = {
    pacte: {
      title: "PACTE",
      category: "Application mobile",
      year: "2025",
      accent: "Produit digital local",
      heroImage: test || null,
      video: null, // ex: pacteVideo
      gallery: [].filter(Boolean),
      intro:
        "PACTE est une application mobile pensée pour dynamiser le commerce local en réunissant fidélité digitale, actualités, événements, notifications et messagerie dans une seule expérience cohérente.",
      context:
        "Le projet est né d'une volonté de moderniser la relation entre commerçants et habitants, avec un outil plus fluide, plus centralisé et plus engageant.",
      goals: [
        "Créer une expérience mobile claire et moderne",
        "Centraliser plusieurs usages dans une seule application",
        "Faciliter la fidélisation et la communication locale",
      ],
      features: [
        "Carte de fidélité digitale",
        "Messagerie utilisateur / commerçant",
        "Actualités locales",
        "Événements",
        "Notifications push",
        "Dashboard d'administration",
      ],
      result:
        "Le projet a abouti à une application complète, pensée comme un véritable produit digital local, avec une attention forte portée à l'expérience utilisateur et à l'évolutivité.",
    },

    savoinimaux: {
      title: "Savoinimaux",
      category: "Site web",
      year: "2025",
      accent: "Refonte de présence digitale",
      heroImage: test || null,
      video: null,
      gallery: [].filter(Boolean),
      intro:
        "Savoinimaux est un projet de refonte web visant à moderniser l'image de l'association et à proposer une présence en ligne plus lisible, plus crédible et plus actuelle.",
      context:
        "L'objectif était de sortir d'une image vieillissante pour proposer un site plus structuré, plus clair et plus cohérent avec les attentes actuelles.",
      goals: [
        "Moderniser l'identité visuelle",
        "Améliorer la lisibilité du site",
        "Renforcer la crédibilité globale de la structure",
      ],
      features: [
        "Refonte visuelle",
        "Nouvelle hiérarchie de contenus",
        "Design plus moderne",
        "Présence digitale plus professionnelle",
      ],
      result:
        "Le projet permet de repositionner l'association avec une image plus nette, plus sérieuse et mieux adaptée aux standards actuels du web.",
    },

    "aj-construction": {
      title: "AJ Construction",
      category: "Présence digitale",
      year: "2026",
      accent: "Performance locale",
      heroImage: test || null,
      video: null,
      gallery: [].filter(Boolean),
      intro:
        "AJ Construction est un accompagnement digital orienté visibilité locale, image de marque et cohérence de communication.",
      context:
        "Le besoin principal était d'améliorer la présence en ligne de l'entreprise et de renforcer sa crédibilité auprès d'une audience locale.",
      goals: [
        "Renforcer la visibilité locale",
        "Valoriser l'image professionnelle",
        "Créer une communication plus cohérente",
      ],
      features: [
        "Optimisation présence en ligne",
        "Stratégie de contenu",
        "Image professionnelle",
        "Visibilité locale",
      ],
      result:
        "Le projet a permis d'apporter une base plus solide à la communication digitale de l'entreprise et d'améliorer la perception globale de son activité.",
    },
  };

  const project = projects[slug];

  if (!project) {
    return (
      <div className="min-h-screen bg-white text-black">
        <NavBar />
        <section className="px-6 py-32">
          <div className="max-w-4xl mx-auto">
            <p className="font-asap uppercase tracking-[0.28em] text-[12px] text-[#b98c42] mb-5">
              Projet
            </p>
            <h1 className="text-[2.6rem] md:text-[4.5rem] leading-[0.95] tracking-[-0.07em] font-[600] font-asap mb-6">
              Projet introuvable
            </h1>
            <p className="text-black/60 font-asap text-[17px] leading-relaxed mb-8 max-w-2xl">
              Le projet demandé n'existe pas encore ou n'est pas encore publié.
            </p>
            <Link
              to="/projects"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-black text-white px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
            >
              Retour aux projets
              <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4 invert" />
            </Link>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  const hasHero = Boolean(project.heroImage);
  const hasVideo = Boolean(project.video);
  const hasGallery = Array.isArray(project.gallery) && project.gallery.length > 0;
  const hasGoals = Array.isArray(project.goals) && project.goals.length > 0;
  const hasFeatures = Array.isArray(project.features) && project.features.length > 0;
  const hasResult = Boolean(project.result);

  return (
    <div className="relative min-h-screen overflow-hidden bg-white text-black selection:bg-black selection:text-white">
      <div className="absolute inset-0 z-0 h-[90vh]">
        <img
          src={bgHero}
          alt="Background"
          className="w-full h-full object-cover pt-20"
        />
      </div>

      <NavBar />

      {/* HERO TEXT */}
      <section className="relative z-10 px-6 pt-20 pb-14 md:pt-24 md:pb-20">
        <div className="max-w-6xl mx-auto">
          <p className="font-asap uppercase tracking-[0.28em] text-[12px] text-[#b98c42] mb-5">
            {project.category}
          </p>

          <h1 className="text-[2.4rem] md:text-[5.4rem] leading-[0.92] tracking-[-0.08em] font-[600] font-asap text-black max-w-5xl">
            {project.title}
          </h1>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <span className="rounded-full border border-black/[0.08] bg-white px-4 py-2 text-[12px] uppercase tracking-[0.18em] font-asap text-black/70">
              {project.year}
            </span>
            {project.accent && (
              <span className="rounded-full border border-[#c9a35f]/20 bg-[#c9a35f]/[0.08] px-4 py-2 text-[12px] uppercase tracking-[0.18em] font-asap text-[#9a7130]">
                {project.accent}
              </span>
            )}
          </div>

          {project.intro && (
            <p className="mt-7 text-[17px] md:text-[21px] text-black/60 max-w-3xl font-asap leading-relaxed">
              {project.intro}
            </p>
          )}
        </div>
      </section>

      {/* HERO IMAGE */}
      {hasHero && (
        <section className="relative z-10 px-6 pb-8">
          <div className="max-w-6xl mx-auto overflow-hidden rounded-[34px] border border-black/[0.06] bg-white shadow-[0_20px_70px_rgba(0,0,0,0.08)]">
            <img
              src={project.heroImage}
              alt={project.title}
              className="w-full h-[320px] md:h-[560px] object-cover"
              loading="lazy"
            />
          </div>
        </section>
      )}

      {/* VIDEO MOCKROCKET */}
      {hasVideo && (
        <section className="relative z-10 px-6 pt-4 pb-8">
          <div className="max-w-6xl mx-auto overflow-hidden rounded-[34px] border border-black/[0.06] bg-white shadow-[0_20px_70px_rgba(0,0,0,0.08)] p-3 md:p-4">
            <video
              autoPlay
              muted
              loop
              playsInline
              controls
              className="w-full rounded-[26px]"
            >
              <source src={project.video} type="video/mp4" />
            </video>
          </div>
        </section>
      )}

      {/* CONTENT */}
      <section className="relative px-6 py-16">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-[0.9fr_1.1fr] gap-10">
          <div className="space-y-6">
            {project.context && (
              <div className="rounded-[32px] border border-black/[0.06] bg-[linear-gradient(180deg,#ffffff_0%,#f7f7f7_100%)] p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)]">
                <p className="font-asap uppercase tracking-[0.24em] text-[10px] text-[#b98c42] mb-4">
                  Contexte
                </p>
                <p className="font-asap text-black/70 leading-relaxed">
                  {project.context}
                </p>
              </div>
            )}

            {hasResult && (
              <div className="rounded-[32px] border border-black/[0.06] bg-black p-8 shadow-[0_18px_60px_rgba(0,0,0,0.18)]">
                <p className="font-asap uppercase tracking-[0.24em] text-[10px] text-[#d1a75f] mb-4">
                  Résultat
                </p>
                <p className="font-asap text-white/75 leading-relaxed">
                  {project.result}
                </p>
              </div>
            )}
          </div>

          <div className="space-y-6">
            {hasGoals && (
              <div className="rounded-[32px] border border-black/[0.06] bg-white p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)]">
                <p className="font-asap uppercase tracking-[0.24em] text-[10px] text-[#b98c42] mb-4">
                  Objectifs
                </p>
                <div className="space-y-3">
                  {project.goals.map((goal, index) => (
                    <div key={goal} className="flex items-start gap-4">
                      <div className="w-8 h-8 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center text-[11px] tracking-[0.14em] font-asap font-[600] text-[#b98c42] shrink-0">
                        0{index + 1}
                      </div>
                      <p className="font-asap text-black/80 leading-relaxed">
                        {goal}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {hasFeatures && (
              <div className="rounded-[32px] border border-black/[0.06] bg-white p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)]">
                <p className="font-asap uppercase tracking-[0.24em] text-[10px] text-[#b98c42] mb-4">
                  Fonctionnalités / axes
                </p>
                <div className="grid sm:grid-cols-2 gap-3">
                  {project.features.map((item) => (
                    <div
                      key={item}
                      className="rounded-[18px] border border-black/[0.06] bg-[#fafafa] px-4 py-3 text-[14px] font-asap text-black"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* GALLERY */}
      {hasGallery && (
        <section className="relative px-6 pb-20">
          <div className="max-w-6xl mx-auto">
            <div className="mb-8">
              <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#b98c42] mb-4">
                Aperçu visuel
              </p>
              <h2 className="text-[2rem] md:text-[3.6rem] leading-[0.95] tracking-[-0.06em] font-[600] font-asap text-black">
                Quelques visuels du projet
              </h2>
            </div>

            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
              {project.gallery.map((image, index) => (
                <div
                  key={`${project.title}-${index}`}
                  className="overflow-hidden rounded-[28px] border border-black/[0.06] bg-white shadow-[0_12px_30px_rgba(0,0,0,0.04)]"
                >
                  <img
                    src={image}
                    alt={`${project.title} visuel ${index + 1}`}
                    className="w-full h-[240px] md:h-[280px] object-cover transition-transform duration-500 hover:scale-[1.03]"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="px-6 pb-32">
        <div className="max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-[48px] bg-black text-white px-8 py-16 md:px-14 md:py-24 shadow-[0_40px_120px_rgba(0,0,0,0.22)]">
            <div className="absolute inset-0 opacity-[0.10]">
              <img src={bgHero} alt="" className="w-full h-full object-cover" />
            </div>

            <div className="relative z-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
              <div className="max-w-3xl">
                <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#d1a75f] mb-5">
                  Un projet similaire ?
                </p>
                <h2 className="text-[2.7rem] md:text-[5rem] leading-[0.94] tracking-[-0.08em] font-[600] font-asap mb-6">
                  Parlons du vôtre
                </h2>
                <p className="text-white/70 text-[17px] md:text-[20px] font-asap leading-relaxed max-w-2xl">
                  Nous pouvons vous accompagner pour concevoir une solution digitale
                  cohérente, élégante et pensée pour durer.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-white text-black px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                >
                  Nous contacter
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </Link>
                <Link
                  to="/projects"
                  className="inline-flex items-center justify-center rounded-full border border-white/[0.18] px-7 py-3.5 font-asap font-medium text-white transition-all duration-300 hover:bg-white hover:text-black"
                >
                  Retour aux projets
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}